export default "__VITE_PUBLIC_ASSET__b7873a48__"